<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    pagination="loadmore"
                    @edit="openForm"
                />
            </div>
        </div>

        <validation-observer v-slot="{ passes, invalid }">
            <a-modal
                v-model="formEnabled"
                :title="id === 0 ? 'Añadir nueva tarifa' : 'Editar tarifa #' + id"
                :ok-text="id === 0 ? 'Añadir' : 'Editar'"
                cancel-text="Cancelar"
                :ok-button-props="{ props: { disabled: invalid } }"
                @ok="passes(save)"
                @cancel="closeForm"
            >
                <form @submit.prevent="passes(save)">
                    <div class="row">
                        <div class="col">
                            <g-field
                                v-model="fields.text"
                                :required="true"
                                :app="app"
                                :item="id"
                                name="text"
                                title="Tarifa"
                            />
                        </div>
                    </div>
                </form>
            </a-modal>
        </validation-observer>
    </div>
</template>

<script>
export default {
    name: 'Rates',
    data() {
        return {
            app: 'rates',
            view: 'rateList',
            columns: [
                {
                    title: 'ID',
                    index: '_EntityId',
                    order: true,
                },
                {
                    title: 'Nombre',
                    index: 'text',
                    order: true,
                    search: true,
                },
                {
                    title: 'Acciones',
                    width: '190px',
                    slot: '_actions',
                },
            ],
            fields: {
                text: '',
            },
            formEnabled: false,
            id: 0,
        }
    },
    created() {
        this.$hub.$on('newRate', () => {
            this.id = 0
            this.formEnabled = true
        })
    },
    beforeDestroy() {
        this.$hub.$off('newRate')
    },
    methods: {
        openForm(item) {
            this.id = item._EntityId
            this.formEnabled = true
        },
        closeForm() {
            this.id = 0
            this.formEnabled = false
        },
        async save() {
            this.loading = true

            const params = { text: this.fields.text }

            let data
            if (this.id > 0) {
                data = await this.$gestios.items('rates').edit({ id: this.id, params })
            } else {
                data = await this.$gestios.items('rates').add({ params, view: this.view })
            }

            if (data.ok) this.formEnabled = false

            this.loading = false
        },
    },
}
</script>

<style lang="scss"></style>
